<div class="card card-custom instance-setting-sidebar">
    <div class="card-body pt-10 accordian-section new-accordian-scroll">
        <h3 class="heading_text">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.INSTANCE_CONFIGURATION_TAB.TITTLE' | transloco }}</h3>

        <!-- Parent -->
        <div *ngFor="let item of allowedItem?.allowedItemTypes" id="{{ item.allowedItemTypeId }}">
            <div class="plant-section">
                <div class="child_section" (click)="itemSelected(item.allowedItemTypeId)" [class.toggled]="item === selectedFirstChild">
                    <p>
                        <a>{{ item.name }}</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- child -->
        <div class="plant-section-child" *ngIf="FirstChild?.length >= 1 && isShow">
            <div class="child_section_title" style="margin-bottom: 0px">
                <h3>{{ selectedFirstChild.name }}</h3>
            </div>

            <div class="filter_section">
                <mat-form-field style="padding: 0px">
                    <input
                        matInput
                        type="text"
                        placeholder="Search"
                        [(ngModel)]="searchtext"
                        (ngModelChange)="onChangePlantList($event, selectedFirstChild.itemId)"
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div *ngIf="filterfirst.length != 0">
                <span *ngFor="let information of filterfirst; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="SeconditemSelected(information, 1)"
                        [class.toggled]="information === selectedChildSecond"
                    >
                        <p>{{ information.name }}</p>
                    </div>
                </span>
            </div>
            <!-- new search section -->
            <div *ngIf="filterfirst.length == 0">
                <span *ngFor="let information of FirstChild; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="SeconditemSelected(information, 1)"
                        [class.toggled]="information === selectedChildSecond"
                    >
                        <p>{{ information.name }}</p>
                    </div>
                </span>
            </div>

            <div class="add_more" *ngIf="FirstChild?.length > 5">
                <a href="javascript:void(0)" (click)="showHideAllHierarchyChild()">MORE +</a>

                <div class="more_product_modal" *ngIf="isShowHierarchyChild">
                    <div class="modal-header">
                        <h4>{{ selectedFirstChild.name }}</h4>
                        <a class="close-icon" href="javascript:void(0)" (click)="showHideAllHierarchyChild(false)">
                            <i class="flaticon2-cross"></i>
                        </a>
                    </div>
                    <div class="modal-body output-lable">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="filter_section">
                                    <mat-form-field>
                                        <input
                                            matInput
                                            type="text"
                                            placeholder="Search"
                                            [(ngModel)]="_searchtext"
                                            (ngModelChange)="_onChangePlantList($event, selectedFirstChild.itemId)"
                                        />
                                        <button mat-button matPrefix mat-icon-button class="search_btn">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div class="section-scroll">
                                    <div *ngIf="_filterfirst.length != 0">
                                        <div class="child_section" *ngFor="let information of _filterfirst" (click)="_SeconditemSelected(information)">
                                            <p>{{ information.name }}</p>
                                        </div>
                                    </div>
                                    <div *ngIf="_filterfirst.length == 0">
                                        <div class="child_section" *ngFor="let information of FirstChild" (click)="_SeconditemSelected(information)">
                                            <p>{{ information.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <!-- second-child -->
        <div class="plant-section-child" *ngIf="SecondchildLayer?.length >= 1 && isShowSecondChild">
            <!--*ngIf="selectedChildPlan?.info?.length >= 1 && isShow"-->
            <div class="child_section_title">
                <h3>{{ selectedChildSecond.name }}</h3>
            </div>

            <div class="filter_section">
                <mat-form-field style="padding: 0px">
                    <input
                        matInput
                        type="text"
                        placeholder="Search"
                        [(ngModel)]="searchtext1"
                        (ngModelChange)="onChangeSecondChild($event, selectedFirstChild.itemId, selectedChildSecond.itemId)"
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div *ngIf="filtersecond.length != 0">
                <span *ngFor="let childinformation of filtersecond; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="ThirditemSelected(childinformation, 1)"
                        [class.toggled]="childinformation === selectedChildThird"
                    >
                        <p>{{ childinformation.name }}</p>
                    </div>
                </span>
            </div>
            <!--new search section-->
            <div *ngIf="filtersecond.length == 0">
                <span *ngFor="let childinformation of SecondchildLayer; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="ThirditemSelected(childinformation, 1)"
                        [class.toggled]="childinformation === selectedChildThird"
                    >
                        <p>{{ childinformation.name }}</p>
                    </div>
                </span>
            </div>

            <div class="add_more" *ngIf="SecondchildLayer?.length > 5">
                <a href="javascript:void(0)" (click)="showHideAllHierarchyChildSecond(true)">MORE +</a>

                <div class="more_product_modal" *ngIf="isShowHierarchyChildSecond">
                    <div class="modal-header">
                        <h4>{{ selectedChildSecond.name }}</h4>
                        <a class="close-icon" href="javascript:void(0)" (click)="showHideAllHierarchyChildSecond(false)"><i class="flaticon2-cross"></i></a>
                    </div>
                    <div class="modal-body output-lable">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="filter_section">
                                    <mat-form-field>
                                        <input
                                            matInput
                                            type="text"
                                            placeholder="Search"
                                            [(ngModel)]="_searchtext1"
                                            (ngModelChange)="_onChangeSecondChild($event, SecondchildLayer.itemId, selectedChildThird.itemId)"
                                        />
                                        <button mat-button matPrefix mat-icon-button class="search_btn">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div class="section-scroll">
                                    <div *ngIf="_filtersecond.length != 0">
                                        <div
                                            class="child_section"
                                            *ngFor="let childinformation of _filtersecond"
                                            (click)="_ThirditemSelected(childinformation)"
                                        >
                                            <p>{{ childinformation.name }}</p>
                                        </div>
                                    </div>
                                    <div *ngIf="_filtersecond.length == 0">
                                        <div
                                            class="child_section"
                                            *ngFor="let childinformation of SecondchildLayer"
                                            (click)="_ThirditemSelected(childinformation)"
                                        >
                                            <p>{{ childinformation.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <!-- last-child -->
        <div class="plant-section-child" *ngIf="ThirdchildLayer?.length >= 1 && isShowThirdChild">
            <!--*ngIf="selectedChildPlan?.info?.length >= 1 && isShow"-->
            <div class="child_section_title">
                <h3>{{ selectedChildThird.name }}</h3>
            </div>

            <div class="filter_section">
                <mat-form-field style="padding: 0px">
                    <input
                        matInput
                        type="text"
                        placeholder="Search"
                        [(ngModel)]="searchtext2"
                        (ngModelChange)="onChangeThirdChild($event, ThirdchildLayer.itemId, selectedChildThird.itemId)"
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div *ngIf="filterThird.length != 0">
                <span *ngFor="let childinformation of filterThird; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="LastitemSelected(childinformation, 1)"
                        [class.toggled]="childinformation === selectedChildLast"
                    >
                        <p>{{ childinformation.name }}</p>
                    </div>
                </span>
            </div>
            <!--new search section-->
            <div *ngIf="filterThird.length == 0">
                <span *ngFor="let childinformation of ThirdchildLayer; index as i">
                    <div
                        class="child_section"
                        *ngIf="i + 1 < 6"
                        (click)="LastitemSelected(childinformation, 1)"
                        [class.toggled]="childinformation === selectedChildLast"
                    >
                        <p>{{ childinformation.name }}</p>
                    </div>
                </span>
            </div>

            <div class="add_more" *ngIf="ThirdchildLayer?.length > 5">
                <a href="javascript:void(0)" (click)="showHideAllHierarchyChildThird(true)">MORE +</a>

                <div class="more_product_modal" *ngIf="isShowHierarchyChildThird">
                    <div class="modal-header">
                        <h4>{{ selectedChildThird.name }}</h4>
                        <a class="close-icon" href="javascript:void(0)" (click)="showHideAllHierarchyChildThird(false)"><i class="flaticon2-cross"></i></a>
                    </div>
                    <div class="modal-body output-lable">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="filter_section">
                                    <mat-form-field>
                                        <input
                                            matInput
                                            type="text"
                                            placeholder="Search"
                                            [(ngModel)]="_searchtext2"
                                            (ngModelChange)="onChangeLastChild($event, ThirdchildLayer.itemId, selectedChildThird.itemId)"
                                        />
                                        <button mat-button matPrefix mat-icon-button class="search_btn">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div class="section-scroll">
                                    <div *ngIf="_filterThird.length != 0">
                                        <div class="child_section" *ngFor="let childinformation of _filterThird" (click)="_LastitemSelected(childinformation)">
                                            <p>{{ childinformation.name }}</p>
                                        </div>
                                    </div>
                                    <div *ngIf="_filterThird.length == 0">
                                        <div class="child_section" *ngFor="let information of ThirdchildLayer" (click)="_LastitemSelected(information)">
                                            <p>{{ information.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        <!-- last-child -->
    </div>
</div>
